(function() {
  let exitIntentTriggered = false;
  const popupElement = document.getElementById('exitIntentPopup');
  if (!popupElement) return;

  const deviceSetting = popupElement.getAttribute('data-device-setting');
  const delaySeconds = parseInt(popupElement.getAttribute('data-delay-seconds')) || 0;
  const pageLoadTime = Date.now();
  const isMobile = window.innerWidth <= 900;

  // Cookie helper functions
  function setCookie(name, value, days) {
    const expires = new Date();
    expires.setDate(expires.getDate() + days);
    document.cookie = name + "=" + value + ";expires=" + expires.toUTCString() + ";path=/";
  }

  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // Check if popup should run based on device setting
  function shouldRunPopup() {
    if (deviceSetting === 'desktop_only' && isMobile) return false;
    if (deviceSetting === 'mobile_only' && !isMobile) return false;
    return true;
  }

  // Don't initialize if device doesn't match setting
  if (!shouldRunPopup()) {
    return;
  }

  // Check if popup was already dismissed (using cookie instead of sessionStorage)
  function wasPopupDismissed() {
    return getCookie("bestsellerPopupDismissed") === "true";
  }

  // Mark popup as dismissed (using cookie that persists for 7 days)
  function markPopupAsDismissed() {
    setCookie("bestsellerPopupDismissed", "true", 7);
  }

  // Exit intent detection
  function detectExitIntent() {
    let mouseY = 0;

    document.addEventListener("mousemove", function (e) {
      mouseY = e.clientY;
    });

    document.addEventListener("mouseleave", function (e) {
      // Check if mouse is leaving from the top of the viewport
      if (e.clientY <= 0 || e.relatedTarget === null) {
        // Check if enough time has passed since page load
        const timeOnPage = (Date.now() - pageLoadTime) / 1000; // Convert to seconds
        const hasMinimumTimeElapsed = timeOnPage >= delaySeconds;

        if (!exitIntentTriggered && !wasPopupDismissed() && hasMinimumTimeElapsed) {
          showBestsellerPopup();
          exitIntentTriggered = true;
        }
      }
    });
  }

  // Show popup
  function showBestsellerPopup() {
    const popup = document.getElementById("exitIntentPopup");
    popup.classList.add("show");
    document.body.style.overflow = "hidden"; // Prevent background scrolling
  }

  // Close popup
  function closeBestsellerPopup() {
    const popup = document.getElementById("exitIntentPopup");
    popup.classList.remove("show");
    document.body.style.overflow = ""; // Restore scrolling
    markPopupAsDismissed(); // Mark as dismissed so it won't show again
  }

  // Close popup when clicking close button
  document.addEventListener("click", function (e) {
    if (e.target.classList.contains("bestseller-popup-close")) {
      closeBestsellerPopup();
    }
  });

  // Close popup when clicking overlay
  document.addEventListener("click", function (e) {
    if (e.target.classList.contains("bestseller-popup-overlay")) {
      closeBestsellerPopup();
    }
  });

  // Mark popup as dismissed when user clicks on a product link (positive interaction)
  document.addEventListener("click", function (e) {
    if (e.target.classList.contains("bestseller-product-cta") || e.target.closest(".bestseller-product-cta")) {
      markPopupAsDismissed();
    }
  });

  // Close popup with Escape key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeBestsellerPopup();
    }
  });

  // Initialize exit intent detection
  detectExitIntent();
})();
